import { render, staticRenderFns } from "./DragAndDropCard.vue?vue&type=template&id=82a2ef78&scoped=true"
import script from "./DragAndDropCard.vue?vue&type=script&lang=ts"
export * from "./DragAndDropCard.vue?vue&type=script&lang=ts"
import style0 from "./DragAndDropCard.vue?vue&type=style&index=0&id=82a2ef78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a2ef78",
  null
  
)

export default component.exports